import { lazy } from 'react'

import i18n from 'modules/core/lib/i18n'
import { NavigationRoutesFn } from 'modules/core/lib/react-router'

const RootPage = lazy(() => import('modules/salary_advance/pages/RootPage'))
const RequestsPage = lazy(() => import('modules/salary_advance/pages/RequestPage'))

export const salaryAdvanceRoutes: NavigationRoutesFn = (navigation) => [
  {
    path: navigation.salaryAdvance.path,
    element: <RootPage />,
    handle: {
      module: 'salary_advance',
      moduleName: () => i18n.t('salary_advance.module_name'),
      meta: () => ({
        title: i18n.t('salary_advance.module_name'),
        subNavigation: [
          {
            title: i18n.t('salary_advance.tabs.requests.title'),
            href: navigation.salaryAdvance.requests.fullPath(),
            index: true,
          },
          // {
          //   title: i18n.t('benefits.tabs.employees.page.title'),
          //   href: navigation.salaryAdvance.requests.fullPath(),
          // },
        ],
      }),
    },
    children: [
      {
        index: true,
        element: <RequestsPage />,
      },
      {
        path: navigation.salaryAdvance.requests.path,
        element: <RequestsPage />,
      },
    ],
  },
]
